import React from 'react';
import { CSelect } from '@coreui/react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { setInitiative } from './actions';
import permissions from '../../../core/configs/permissions';
import useCanPermissions from '../../../core/hooks/useCanPermissions';
import './styles.scss';
import { disabledPathes } from '../constants';

const InitiativeSelectContainer = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { isCan } = useCanPermissions();
  const { initiativesOnLoading, organizationsOnLoading, initiatives, initiativeId } = useSelector(
    ({ globalSelections }) => globalSelections,
  );

  const activeInitiatives = initiatives
    .filter(({ is_active }) => is_active)
    .sort((a, b) => a.campaign_name.localeCompare(b.campaign_name));

  const onInitiativeSelectChange = React.useCallback(
    ({ target }) => {
      dispatch(setInitiative(target.value));
    },
    [dispatch],
  );

  const isDisabled = React.useMemo(
    () => disabledPathes.some((path) => pathname.includes(path)),
    [pathname],
  );

  return (
    <div className="initiative-select">
      <CSelect
        custom
        name="initiatives"
        id="initiatives"
        value={initiativeId || 0}
        onChange={onInitiativeSelectChange}
        className="mxw-20rem mxw-100-xs"
        disabled={isDisabled || initiativesOnLoading || organizationsOnLoading}
      >
        <option disabled value={0}>
          Select Initiative
        </option>
        {isCan({
          permission: permissions.select_admin_mode,
          initiativeMode: true,
          adminMode: true,
        }) && <option value="admin">Admin</option>}
        {activeInitiatives.map((o) => (
          <option value={o.id} key={o.id}>
            {o.campaign_name}
          </option>
        ))}
      </CSelect>
    </div>
  );
};

export default InitiativeSelectContainer;
